const menuConfig = [
  {
    key: "dashboard",
    icon: "bi bi-speedometer2",
    label: "Dashboard",
    children: [
      { key: "dashboard", path: "/dashboard", label: "Dashboard" },
      {
        key: "activity-logs",
        path: "/activity-logs",
        label: "Activity Logs",
        permission: "read activity_logs",
      },
      {
        key: "migration-seeder",
        path: "/migration-seeder",
        label: "Migration & Seeder",
        superAdminOnly: true,
      },
      {
        key: "database-backup",
        path: "/database-backup",
        label: "Database Backup",
        superAdminOnly: true,
      },
    ],
  },
  {
    key: "accounts",
    icon: "bi bi-people",
    label: "Accounts",
    permissions: ["read admins", "read users", "read roles"],
    children: [
      {
        key: "admins",
        path: "/admins",
        label: "Admins",
        permission: "read admins",
      },
      {
        key: "users",
        path: "/users",
        label: "Users",
        permission: "read users",
      },
      {
        key: "roles",
        path: "/roles",
        label: "Roles",
        permission: "read roles",
      },
    ],
  },
  {
    key: "catalog",
    icon: "bi bi-box-seam",
    label: "Catalog",
    permissions: ["read categories", "read products", "read attributes"],
    children: [
      {
        key: "categories",
        path: "/categories",
        label: "Categories",
        permission: "read categories",
      },
      {
        key: "products",
        path: "/products",
        label: "Products",
        permission: "read products",
      },
      {
        key: "attributes",
        path: "/attributes",
        label: "Attributes",
        permission: "read attributes",
      },
    ],
  },
  {
    key: "crm",
    icon: "bi bi-chat-dots",
    label: "CRM",
    permissions: ["read newsletters", "read contacts"],
    children: [
      {
        key: "contacts",
        path: "/contacts",
        label: "Contacts",
        permission: "read contacts",
      },
      {
        key: "news-letters",
        path: "/news-letters",
        label: "News Letters",
        permission: "read newsletters",
      },
    ],
  },
  {
    key: "addresses",
    icon: "bi bi-geo-alt",
    label: "Addresses",
    permissions: ["read addresses"],
    children: [
      { key: "countries", path: "/countries", label: "Countries" },
      { key: "cities", path: "/cities", label: "Cities" },
      { key: "states", path: "/states", label: "States" },
    ],
  },
  {
    key: "offers",
    icon: "bi bi-tag",
    label: "Coupons",
    permissions: ["read coupons"],
    children: [
      {
        key: "coupons",
        path: "/coupons",
        label: "Coupons",
        permission: "read coupons",
      },
    ],
  },
  {
    key: "orders",
    icon: "bi bi-bag-check",
    label: "Orders",
    permissions: ["read orders"],
    children: [
      {
        key: "orders",
        path: "/orders",
        label: "Orders",
        permission: "read orders",
      },
    ],
  },
  {
    key: "general-settings",
    icon: "bi bi-gear",
    label: "Settings",
    permissions: ["update settings"],
    children: [
      { key: "basic-settings", path: "/basic-settings", label: "Basic Settings" },
      { key: "homepage-settings", path: "/homepage-settings", label: "Homepage Settings" },
      { key: "smtp-settings", path: "/smtp-settings", label: "SMTP" },
      {
        key: "payment-gateway-settings",
        path: "/payment-gateway-settings",
        label: "Payments Gateway",
      },
      {
        key: "languages-settings",
        path: "/languages-settings",
        label: "Languages",
      },
      {
        key: "sliders-settings",
        path: "/sliders-settings",
        label: "Sliders",
      },
      {
        key: "banners-settings",
        path: "/banners-settings",
        label: "Banners",
      },
      {
        key: "currencies",
        path: "/currencies",
        label: "Currencies",
        permission: "read currencies",
      },
      {
        key: "email-templates",
        path: "/email-templates",
        label: "Email Templates",
        permission: "update settings",
      },
      {
        key: "partners",
        path: "/partners",
        label: "Partners",
        permission: "read partners",
      },
      {
        key: "oto-settings",
        path: "/oto-settings",
        label: "OTO Shipping",
        permission: "update settings",
      },
    ],
  },
];

export default menuConfig;
